import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import {
  environment,
  MyHttpClientFactory,
  ResponseCasingEnum,
} from '@ups/xplat/core';
import { AzureProviderTokenDto } from '@ups/xplat/api/dto';
import { filter, interval, ReplaySubject, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AzureFileProviderTokenService {
  http: HttpClient;
  constructor(httpClientFactory: MyHttpClientFactory) {
    this.http = httpClientFactory.createHttpClient(
      environment.urls.fileManagementAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  token() {
    return this.http.post<AzureProviderTokenDto>(
      '/api/AzureProviderToken/token',
      null
    );
  }

  /**
   * DONT FORGET TO CALL COMPLETE WHEN NOT NEEDED ANYMORE
   */
  tokenStream() {
    const subject = new ReplaySubject<
      | { status: 'unsupported' }
      | { status: 'error'; error: unknown }
      | { status: 'ok'; token: string; expiresAt: number }
    >(1);

    const run = () => {
      console.log('AzureFileProviderTokenService: run');

      if (subject.closed) return;

      this.token().subscribe({
        next: (x) => {
          subject.next({
            status: 'ok',
            token: x.token,
            expiresAt: x.expiresAt,
          });
        },
        error: (x) => {
          if (x instanceof HttpErrorResponse) {
            if (x.status === HttpStatusCode.NotFound) {
              console.log(
                'AzureFileProviderTokenService: token api not supported'
              );
              subject.next({ status: 'unsupported' });
              return;
            }
          }

          console.error('AzureFileProviderTokenService', x);

          subject.next({ status: 'error', error: x });
        },
      });
    };

    const sub = subject
      .pipe(
        filter((x) => x.status === 'ok'),
        switchMap((x) => {
          const refreshIn = Math.max(
            x.expiresAt * 1000 - Date.now() - 60_000,
            0
          );

          console.log('AzureFileProviderTokenService: refresh in', refreshIn);

          return interval(refreshIn).pipe(take(1));
        })
      )
      .subscribe(() => run());

    subject.subscribe({ complete: () => sub.unsubscribe() });

    run();

    return subject;
  }
}
